import { Group } from '@mantine/core'
import { CustomLoader } from './loader'

export const CustomLoaderPage = () => {
  return (<Group className="loaderPage" position="center"><CustomLoader /></Group>
  )
}